export default {"src":"/_next/static/media/mode_computer_easy.f1dac7ed.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};